<template>
    <AppModal v-model:is-show="isShowModel" :title="$t('pages.student.home.languageSetting.title')">
        <div class="info_text">
            <p>{{ $t('pages.student.home.languageSetting.description') }}</p>
            <div class="language_list">
                <button
                    v-for="lang in SUPPORTED_LOCALES"
                    :key="lang.code"
                    :class="selectedLocale === lang.code ? 'is_selected' : ''"
                    @click="selectedLocale = lang.code"
                >
                    <i class="flag_icon" :class="lang.code" />
                    <span>{{ lang.label }}</span>
                </button>
            </div>
        </div>
        <template #btns>
            <button class="btn_cancel" type="button" @click="isShowModel = false">
                <span>{{ $t('buttons.cancel') }}</span>
            </button>
            <button class="btn_save" type="button" @click="handleLanguageSave">
                <span>{{ $t('buttons.save') }}</span>
            </button>
        </template>
    </AppModal>
</template>

<script setup lang="ts">
    import { computed, ref, watch } from 'vue';
    import AppModal from '@/app/components/modals/AppModal.vue';
    import { useSystemStoreWithOut } from '@/app/stores/system';
    import { SUPPORTED_LOCALES } from '@/app/lang/locales';

    const props = defineProps<{
        isShow: boolean;
    }>();

    const emit = defineEmits<{
        'update:isShow': [value: boolean];
    }>();

    const isShowModel = computed({
        get: () => props.isShow,
        set: (value) => emit('update:isShow', value),
    });

    const systemStore = useSystemStoreWithOut();
    const selectedLocale = ref(systemStore.locale);

    // 모달이 열릴 때마다 현재 적용된 언어로 선택 상태를 초기화
    watch(
        () => props.isShow,
        (show) => {
            if (show) {
                selectedLocale.value = systemStore.locale;
            }
        },
    );

    function handleLanguageSave() {
        systemStore.changeLocale(selectedLocale.value);
        isShowModel.value = false;
    }
</script>
